import { render, staticRenderFns } from "./PromoCampaignModal.vue?vue&type=template&id=fa6885a0&scoped=true"
import script from "./PromoCampaignModal.vue?vue&type=script&lang=js"
export * from "./PromoCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./PromoCampaignModal.vue?vue&type=style&index=0&id=fa6885a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6885a0",
  null
  
)

export default component.exports